import React from "react";

const emptyFunc = () => {
  // noop
};
const Overlay: React.FC<{ close: () => void }> = ({ close }) => (
    <div
      onKeyDown={emptyFunc} role="button" tabIndex={0}
      className="fixed inset-0 z-[60] bg-overlay dark:bg-overlay-dark opacity-30 overflow-hidden"
      onClick={close}
    />
  );

export default Overlay;
